<template>
  <!-- 顶部导航 -->
  <div>
    <!-- <div class="empty_space" @mouseover.native="mouseOverHome"></div> -->
    <div ref="bigmenuShow" class="bigmenu">
      <div class="containers bigmenuMain">
        <!-- logo -->
        <a class="logo-out-box" v-show="activeindex == 0" href="../../index.html">
          <img class="logo" :src="logUrl">
        </a>
        <!-- <img v-show="activeindex == 0" class="logo" :src="logUrl"> -->
        <!-- 一级导航 -->
        <div class="menu">
          <ul class="headerLog" :style="{opacity:(activeindex == 0 ? '1' : '0')}">
            <li>
              <router-link :to="{path:'/home'}" @mouseover.native="mouseOverHome"><span>网站首页</span></router-link>
            </li>
            <li>
              <router-link @mouseover.native="mouseOver('产品中心')" :to="{path:'/comdedeauto'}"><span>产品中心</span></router-link>
            </li>
            <li>
              <router-link @mouseover.native="mouseOver('解决方案')" :to="{path:'/solutionadmi'}"><span>解决方案</span></router-link>
            </li>
            <li>
              <router-link @mouseover.native="mouseOver('新闻动态')" :to="{path:'/companyNews'}"><span>新闻动态</span></router-link>
            </li>
            <li>
              <router-link @mouseover.native="mouseOver('关于我们')" :to="{path:'/companyprofile'}"><span>关于我们</span></router-link>
            </li>
            <li>
              <router-link @mouseover.native="mouseOver('职等你来')" :to="{path:'/jobmarket'}"><span>职等你来</span></router-link>
            </li>
          </ul>
          <!-- 最右侧icon，打开总导航页面 -->
          <div class="btnMenuIcon" @mouseover="mouseOverHome" @click="openSumMenu">
            <span ref="openSumNavBtn" :class="activeindex== 0?'header__hamburgerbar':'header__hamburgerbar header__hamburgerbar_border'"></span>
          </div>

        </div>
      </div>
      <!-- 二级导航 -->
      <div ref="childMeun" @mouseleave="mouseLeave()">
        <div v-show="childMeunShow==='产品中心'" class="submenu">
          <router-link :to="{path:'/comdedeauto'}">得得用车</router-link>
        </div>
        <div v-show="childMeunShow==='解决方案'" class="submenu">
          <router-link :to="{path:'/solutionadmi'}">人员准入</router-link>
          <router-link :to="{path:'/solutionSafety'}">安全工器具</router-link>
          <router-link :to="{path:'/projectassets'}">“项目+资产”移动作业系统</router-link>
        </div>
        <div v-show="childMeunShow==='新闻动态'" class="submenu">
          <!-- <a>新闻聚焦</a> -->
          <router-link :to="{path:'/companyNews'}">新闻聚焦</router-link>
          <router-link :to="{path:'/companyDynamic'}">文化活动</router-link>
        </div>
        <div v-show="childMeunShow==='关于我们'" class="submenu">
          <router-link :to="{path:'/companyprofile'}">公司简介</router-link>
          <router-link :to="{path:'/companyculture'}">企业文化</router-link>
          <!-- <router-link :to="{path:'/companyprofile'}">总经理寄语</router-link> -->
          <router-link :to="{path:'/honorqualification'}">荣誉资质</router-link>
          <router-link :to="{path:'/contactus'}">联系我们</router-link>
        </div>
        <div v-show="childMeunShow==='职等你来'" class="submenu">
          <router-link :to="{path:'/jobmarket',query:{type:'sh'}}">社会招聘</router-link>
          <router-link :to="{path:'/jobmarket',query:{type:'xxs'}}">实习生招聘</router-link>
        </div>
      </div>
    </div>

    <!-- 总导航页 -->
    <div ref="sumNav" class="sumNav">
      <div class="sumNav_logo">
        <a href="../../index.html">
          <img src="../../assets/imgs/componentsPic/logo.png" class="logo">
        </a>
      </div>

      <div class="sumNav_meun">
        <dl>
          <dt>产品中心</dt>
          <dd>
            <router-link :to="{path:'/comdedeauto'}">得得用车</router-link>
          </dd>
        </dl>

        <dl>
          <dt>解决方案</dt>
          <dd>
            <router-link :to="{path:'/solutionadmi'}">人员准入</router-link>
          </dd>
          <dd>
            <router-link :to="{path:'/solutionSafety'}">安全工器具</router-link>
          </dd>
          <dd>
            <router-link :to="{path:'/projectassets'}">“项目+资产”移动作业系统</router-link>
          </dd>
        </dl>

        <dl>
          <dt>新闻动态</dt>
          <dd>
            <router-link :to="{path:'/companyNews'}">新闻聚焦</router-link>
          </dd>
          <dd>
            <router-link :to="{path:'/companyDynamic'}">文化活动</router-link>
          </dd>
        </dl>

        <dl>
          <dt>关于我们</dt>
          <dd>
            <router-link :to="{path:'/companyprofile'}">公司简介</router-link>
          </dd>
          <dd>
            <router-link :to="{path:'/companyculture'}">企业文化</router-link>
          </dd>
          <!-- <dd>
                        <router-link :to="{path:'/companyprofile'}">总经理寄语</router-link>
                    </dd> -->
          <dd>
            <router-link :to="{path:'/honorqualification'}">荣誉资质</router-link>
          </dd>
          <dd>
            <router-link :to="{path:'/contactus'}">联系我们</router-link>
          </dd>
        </dl>

        <dl>
          <dt>职等你来</dt>
          <dd>
            <router-link :to="{path:'/jobmarket',query:{type:'sh'}}">社会招聘</router-link>
          </dd>
          <dd>
            <router-link :to="{path:'/jobmarket',query:{type:'xxs'}}">实习生招聘</router-link>
          </dd>
        </dl>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      logUrl: require("../../assets/imgs/componentsPic/logo.png"),
      childMeunShow: "",
      isSumNav: true,
    };
  },
  props: {
    activeindex: {
      type: [String, Number],
      default: 0,
    },
  },

  mounted() {
    // console.log(this.activeindex);
    window.addEventListener("scroll", this.menu);
  },
  beforeDestroy() {
    //在加载时添加了scroll监听，如果不销毁，到下一个页面时，没有主动销毁，会报错'offsetTop' of undefined。因此，需要在页面跳转前销毁此监听
    window.removeEventListener("scroll", this.menu);
  },

  watch: {
    $route: {
      //监听路由参数发生变化时，就将总导航隐藏
      handler() {
        this.isSumNav = true;
        this.$refs.sumNav.classList.remove("openSumNav");
        this.$refs.openSumNavBtn.classList.remove("activedHamburgerbar"); //将按钮变成X
      },
      deep: true,
    },
  },

  methods: {
    menu() {
      if (window.pageYOffset > 100) {
        this.$refs.openSumNavBtn.classList.add("header__hamburgerbar_border"); //将按钮变成待打开
      } else {
        this.$refs.openSumNavBtn.classList.remove(
          "header__hamburgerbar_border"
        ); //将按钮变
      }
    },

    //当鼠标移入一级菜单时，一级菜单文字样式更改
    overMeunFristStyle() {
      let childrenA =
        this.$refs.bigmenuShow.children[0].children[1].children[0].children;
      for (let i = 1; i < childrenA.length; i++) {
        childrenA[i].children[0].classList.add("menuOpenChild");
        childrenA[0].children[0].classList.add("menuOpenChild");
      }
      this.logUrl = require("../../assets/imgs/componentsPic/logo_hover.png");
    },
    leaveMeunFristStyle() {
      let childrenA =
        this.$refs.bigmenuShow.children[0].children[1].children[0].children;
      for (let i = 0; i < childrenA.length; i++) {
        childrenA[i].children[0].classList.remove("menuOpenChild");
      }
      this.logUrl = require("../../assets/imgs/componentsPic/logo.png");
    },

    //鼠标移入移除时添加类名显示/隐藏二级菜单
    mouseOver(val) {
      if (this.activeindex != 0) {
        return;
      }
      this.$refs.childMeun.classList.add("childMeun");
      this.$refs.childMeun.classList.remove("downchildMeun");
      this.$refs.bigmenuShow.classList.add("bigmenuShow");
      this.$refs.bigmenuShow.classList.remove("bigmenuDown");
      this.overMeunFristStyle();
      this.childMeunShow = val;
      this.$refs.openSumNavBtn.classList.add("header__hamburgerbar_border");
    },
    mouseLeave() {
      if (this.activeindex != 0) {
        return;
      }
      this.$refs.childMeun.classList.remove("childMeun");
      this.$refs.childMeun.classList.add("downchildMeun");
      this.$refs.bigmenuShow.classList.remove("bigmenuShow");
      this.$refs.bigmenuShow.classList.add("bigmenuDown");
      this.leaveMeunFristStyle();
      this.childMeunShow = "";
      this.$refs.openSumNavBtn.classList.remove("header__hamburgerbar_border");
    },
    //通过网站首页，鼠标移入移除时添加类名显示/隐藏二级菜单
    mouseOverHome() {
      if (this.activeindex != 0) {
        return;
      }
      this.mouseLeave();
      this.$refs.openSumNavBtn.classList.add("header__hamburgerbar_border");
    },
    //打开总导航
    openSumMenu() {
      if (this.isSumNav) {
        this.$refs.sumNav.classList.add("openSumNav");
        this.$refs.sumNav.classList.remove("downSumNav");
        this.isSumNav = false;
        this.$refs.openSumNavBtn.classList.add("activedHamburgerbar"); //将按钮变成X
      } else {
        this.$refs.sumNav.classList.remove("openSumNav");
        this.$refs.sumNav.classList.add("downSumNav");
        this.isSumNav = true;
        this.$refs.openSumNavBtn.classList.remove("activedHamburgerbar"); //将按钮变成待打开
      }
    },
  },
};
</script>

<style scoped>
</style>
<style>
.headerLog {
  transition: opacity 0.2s;
}
</style>